export default "../images/logo-x-large.svg?8c04f73aca0c1e2db5fb2643bc709858";